import {
	Component,
	EventEmitter,
	Input,
	OnDestroy,
	OnInit,
	Output,
} from '@angular/core';
import { Router } from '@angular/router';
import { emptyCompany } from 'src/app/models/data/company';
import { SystemCapabilityItem } from 'src/app/models/data/systemCapability';
import { Mode, UserProfile } from 'src/app/models/model';
import { ApiService } from 'src/app/services/api.services';
import { AuthService } from 'src/app/services/auth.service';
import { NavigationHistoryService } from 'src/app/services/navigation-history.service';
import { EditRole } from 'src/app/ui/roles/add-role/add-role-main-tab.component';
import { SystemCapabilityTableComponent } from '../../components/system-capability-table/system-capability-table.component';
import { NotAuthorizedNoticeComponent } from '../../../../components/not-authorized-notice/not-authorized-notice.component';
import { HasSystemCapabilityDirective } from '../../../../directives/system-capabilities/has-system-capability.directive';
import { MatDivider } from '@angular/material/list';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';

@Component({
	selector: 'app-add-role-define',
	templateUrl: './add-role-define.component.html',
	styleUrls: ['./add-role-define.component.scss', '../../../common/main.scss'],
	imports: [
		NotAuthorizedNoticeComponent,
		HasSystemCapabilityDirective,
		MatDivider,
		MatFormField,
		MatLabel,
		MatInput,
		FormsModule,
		SystemCapabilityTableComponent,
	],
})
export class AddRoleDefineComponent implements OnInit, OnDestroy {
	@Input() companyId?: string;
	@Input() editRole!: EditRole;

	company = emptyCompany();
	companyType?: 'advanced' | 'care';
	mode: Mode = Mode.create;

	activeCompanyId?: string;
	authSubscription: any;

	constructor(
		private readonly apiService: ApiService,
		private readonly router: Router,
		private readonly authService: AuthService,
		private readonly navHistory: NavigationHistoryService
	) {
		this.authSubscription = this.authService
			.userSession()
			.subscribe((session) => {
				this.activeCompanyId =
					session.assignedRole?.entityRelationship?.parentEntityId;
			});
	}

	async ngOnInit(): Promise<void> {
		this.apiService.getRoleCapabilities().then((systemCapabilities) => {
			this.editRole.systemCapabilityItems = systemCapabilities.map(
				(systemCapability): SystemCapabilityItem => ({ systemCapability })
			);
		});

		if (this.companyId) {
			const response = await this.apiService.getCompanyById(this.companyId);
			this.company = response.company;
			this.companyType = response.company?.companyType;
		} else {
			const response = await this.apiService.getUserProfile();
			this.company = response?.activeRoleDetails?.company ?? emptyCompany();
			this.companyType = this.company?.companyType;
		}
	}

	systemCapabilitiesToggleEvents(event: any): void {
		const activeCapability = this.editRole.systemCapabilityItems.find(
			(it) => it.systemCapability.id === event.systemCapability.id
		);
		const index = this.editRole.systemCapabilityItems.findIndex(
			(it) => it.systemCapability.id === event.systemCapability.id
		);

		if (activeCapability !== undefined) {
			this.editRole.systemCapabilityItems[index].granted = event.granted;
		} else {
			// This should never be called
			console.error(
				`Selected System Capability was not found: ${activeCapability}`
			);
		}
	}

	get isValid(): boolean {
		const roleNameExists = this.editRole.name.length > 0;
		const scSelected =
			this.editRole.systemCapabilityItems.filter((sc) => sc.granted === true)
				.length > 0;
		return roleNameExists && scSelected;
	}

	get continueButtonDisabled(): boolean {
		const invalidRoleName = this.editRole.name.length === 0;
		const invalidNewRoleInformation =
			this.editRole.name.length === 0 ||
			this.editRole.systemCapabilityItems.filter((item) => !!item.granted)
				.length === 0;
		return invalidRoleName || invalidNewRoleInformation;
	}

	exitRoleCreation(): void {
		this.navHistory.navigateBack();
	}

	ngOnDestroy(): void {
		this.authSubscription.unsubscribe();
		this.authSubscription = undefined;
	}
}
